module.exports = __webpack_public_path__ + "img/logo_vector.07b51641.svg";